import { Service, StatefulService } from 'react-service-locator';
import axiosInstance from '../axios/axiosAuthInterceptor';

type ISymptom = {
    id: number;
    value: string;
};

type IDisease = {
    id: number;
    value: string;
    subCategories: ISymptom[];
    symptoms: ISymptom[];
};

@Service()
export class DiseaseService extends StatefulService<{
    diseases: string[];
    subcategories: string[];
    symptoms: string[];
}> {
    private disease_symptoms: IDisease[] = [];

    constructor() {
        super({ diseases: [], subcategories: [], symptoms: [] });
        void this.fetchDiseases();
    }

    async fetchDiseases(): Promise<void> {
        try {
            const response = await axiosInstance.get('/Disease/all');
            this.disease_symptoms = response.data as IDisease[];

            const diseases = this.disease_symptoms.map((c) => c.value);
            this.setState({ diseases });
        } catch (err) {
            console.error('Failed to fetch diseases', err);
            this.setState({ diseases: [], subcategories: [], symptoms: [] });
        }
    }

    setDisease(disease?: string): void {
        const selected = this.disease_symptoms.find((c) => c.value === disease);

        const symptoms = selected?.symptoms?.map((d) => d.value) ?? [];

        const subcategories = selected?.subCategories?.map((d) => d.value) ?? [];

        this.setState({ symptoms, subcategories });
    }
}
